import React, { useEffect, useState } from "react";
import ProductDetailsSkeleton from "./ProductDetailsSkeleton";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { Link, useParams, useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useDispatch, useSelector } from "react-redux";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import Ratings from "../components/Ratings";
import { AiFillHeart } from "react-icons/ai";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import Reviews from "../components/Reviews";
import { get_product } from "../store/reducers/homeReducer";
import ShareButton from "./shareButton"
import { formatCurrency } from "../utils/currencyUtils";
import { useCurrency } from "../hooks/useCurrency"
import {
  add_to_card,
  messageClear,
  add_to_wishlist,
  remove_wishlist,
} from "../store/reducers/cardReducer";
import toast from "react-hot-toast";
import {
  ChevronRight,
  Copy,
  Heart,
  MessageSquare,
  Minus,
  Package,
  Plus,
  Share,
  Share2,
  ShoppingBag,
  Trophy,
} from "lucide-react";
import { Button } from "../components/ui/button";
const Details = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { slug } = useParams();
  const { currencyCode, exchangeLoaded } = useCurrency()
  const dispatch = useDispatch();
  const { product, relatedProducts, moreProducts, error } = useSelector(
    (state) => state.home
  );
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, successMessage, wishlist } = useSelector((state) => state.card);
  const [image, setImage] = useState("");
  const [state, setState] = useState("description");
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mdtablet: {
      breakpoint: { max: 991, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 3,
    },
    smmobile: {
      breakpoint: { max: 640, min: 0 },
      items: 2,
    },
    xsmobile: {
      breakpoint: { max: 440, min: 0 },
      items: 1,
    },
  };

  const [quantity, setQuantity] = useState(1);

  const inc = () => {
    if (quantity >= product.stock) {
      toast.error("Out of stock");
    } else {
      setQuantity(quantity + 1);
    }
  };

  const dec = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const add_card = () => {
    if (userInfo) {
      dispatch(
        add_to_card({
          userId: userInfo.id,
          quantity,
          productId: product._id,
        })
      );
    } else {
      navigate("/login");
    }
  };

  const inWishlist = wishlist.find(w => product && (w.productId === product._id?.toString() || w.productId === product._id));

  const toggle_wishlist = () => {
    if (!userInfo) { navigate("/login"); return; }
    if (inWishlist) {
      dispatch(remove_wishlist(inWishlist._id));
    } else {
      dispatch(add_to_wishlist({
        userId: userInfo.id,
        productId: product._id,
        name: product.name,
        price: product.price,
        image: product.images[0],
        discount: product.discount || 0,
        rating: product.rating,
        slug: product.slug,
      }));
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        await dispatch(get_product(slug)).unwrap();
      } catch (err) {
        console.log('Error fetching product:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [slug, dispatch]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
  }, [errorMessage, successMessage]);

  const buy = () => {
    let price = product.price;
  
    // Apply product discount if available
    if (product.discount !== 0) {
      price = product.price - Math.floor((product.price * product.discount) / 100);
    }
  
    // If there's an additional 5% discount, apply it (if necessary)
    let finalPrice = price; // Default to the computed price
    const applyExtraDiscount = false; // Change this to true if needed
  
    if (applyExtraDiscount) {
      finalPrice = price - Math.floor((price * 5) / 100);
    }
  
    const obj = [
      {
        sellerId: product.sellerId,
        shopName: product.shopName,
        price: quantity * finalPrice,
        products: [
          {
            quantity,
            productInfo: product,
          },
        ],
      },
    ];
  
    console.log(obj[0].price);
  
    navigate("/shipping", {
      state: {
        products: obj,
        price: obj[0].price, // Ensure price is consistent
        items: 1,
      },
    });
  };
  
  if (loading) {
    return (
      <div>
        <Headers />
        <ProductDetailsSkeleton />
        <Footer />
      </div>
    );
  }
  
  if (errorMessage || !product || Object.keys(product).length === 0) {
    return (
        <div>
          <Headers />
          <div className="min-h-screen bg-gray-50">
            <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] mx-auto py-24">
              <div className="flex flex-col items-center justify-center gap-6 text-center">
                <Package className="w-16 h-16 text-gray-400" />
                <h1 className="text-3xl font-bold text-gray-900">Product Not Available</h1>
                <p className="text-gray-400 max-w-md">
                  Sorry, the product you're looking for is currently not available or may have been removed.
                </p>
                <div className="flex items-center gap-2 text-gray-400">
                  <Link to="/" className="text-gray-700 hover:text-green-600 transition-colors">
                    Return to Home
                  </Link>
                  <ChevronRight size={16} />
                  <Link to="/products" className="text-gray-700 hover:text-green-600 transition-colors">
                    Browse Products
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>

    )
}

  return (
    <div>
      <Headers />
      <div
  className="h-[220px] bg-cover bg-no-repeat relative bg-left"
  style={{
    backgroundImage: `url(${
      product?.banner?.banner
        ? product.banner.banner
        : `${process.env.REACT_APP_URL}/images/banner/bannermain.jpg`
    })`,
  }}
>
  <div className="absolute left-0 top-0 w-full h-full bg-[#0000008a]">
    <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
      <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
        <h2 className="text-3xl font-bold">{product.name}</h2>
      </div>
    </div>
  </div>
</div>

      <div className="bg-gray-50 py-5 mb-5">
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="flex justify-start items-center text-md text-gray-400 w-full">
            <Link to="/">Home</Link>
            <span className="">
              <ChevronRight size={18} />
            </span>
            <Link to={`/products?category=${product.category}`}>
              {product.category}
            </Link>
            <span className="">
              <ChevronRight size={18} />
            </span>
            <span className="text-gray-900">{product.name}</span>
          </div>
        </div>
      </div>
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="grid grid-cols-2 md-lg:grid-cols-1 gap-8">
            <div>
              <div className="">
                <img
                  className="nex_img_cover sm:h-[300px] h-[400px] w-full"
                  src={image ? image : product.images?.[0]}
                  alt=""
                />
              </div>
              <div className="py-3">
                {product.images && (
                  <Carousel
                    autoPlay={true}
                    infinite={true}
                    responsive={responsive}
                    transitionDuration={500}
                  >
                    {product.images.map((img, i) => {
                      return (
                        <div
                          key={i}
                          className="px-2 w-full"
                          onClick={() => setImage(img)}
                        >
                          <img
                            className="nex_img_cover cursor-pointer  nex_border_sm"
                            src={img}
                            alt=""
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                )}
              </div>
            </div>
            <div className="flex flex-col gap-5">
              <div className="text-3xl text-gray-900 font-bold">
                <h2>{product.name}</h2>
              </div>
              <div className="flex items-center gap-2 text-gray-700 flex-wrap">
                <span className="flex items-center">From {product.shopName} <Package className="ml-2" size="18" /></span>
                {product.sellerInfo?.isTopSeller && (
                  <span className="inline-flex items-center gap-1 bg-yellow-400 text-black text-xs px-3 py-1 rounded-full font-semibold">
                    <Trophy size={12} />
                    Top Seller
                  </span>
                )}
              </div>
              <div className="flex justify-start items-center gap-4">
                <div className="flex text-xl">
                  <Ratings ratings={product.rating} />
                </div>
              </div>

              <div className="text-2xl text-green-500 font-bold flex gap-3">
                {product.discount !== 0 ? (
                  <>
                    <h2>
                    {" "}
                      {formatCurrency(product.price -
                        Math.floor((product.price * product.discount) / 100), currencyCode, exchangeLoaded)}
                    
                    </h2>
                    <h2 className="line-through text-[#3e3e3e]">
                    {formatCurrency(product.price, currencyCode, exchangeLoaded)}
                      
                    </h2>
                  </>
                ) : (
                  <h2>Price : {formatCurrency(product.price, currencyCode, exchangeLoaded)}</h2>
                )}
              </div>
              <div className="text-gray-700">
                <p className="whitespace-pre-wrap break-words">{product.description}</p>
              </div>
              <div className="flex gap-3 pb-10 items-center cursor-pointer">
                {product.stock ? (
                  <>
                    <div className="flex bg-gray-100 rounded-[30px] h-[40px] justify-center items-center text-xl">
                      <div onClick={dec} className="px-6 cursor-pointer">
                        <Minus size={18} />
                      </div>
                      <div className="px-5">{quantity}</div>
                      <div onClick={inc} className="px-6 cursor-pointer">
                        <Plus size={18} />
                      </div>
                    </div>
                    <div>
                      <Button onClick={add_card} className="h-[40px]">
                        Add to cart
                      </Button>
                    </div>
                  </>
                ) : (
                  ""
                )}

                <Heart
                  onClick={toggle_wishlist}
                  className={`cursor-pointer transition-colors ${inWishlist ? 'fill-red-500 text-red-500' : 'text-gray-400 hover:text-red-400'}`}
                />
              </div>
              <div className="flex py-5 gap-5">
                <div className="w-[150px] text-gray-700 text-xl flex flex-col gap-5">
                  <span>Availability</span>
                  <span>Share</span>
                </div>
                <div className="flex flex-col gap-5">
                  <span
                    className={`text-${product.stock ? "white" : "red"}-500`}
                  >
                    {product.stock
                      ? `In Stock(${product.stock})`
                      : "Out of Stock"}
                  </span>
               <ul>
               <ShareButton />
               </ul>
                </div>
              </div>
              <div className="flex gap-3">
                {product.stock ? (
                  <button
                    onClick={buy}
                    className="flex items-center nex_button button_200 font-semibold text-black h-[40px]"
                  >
                    Buy Now <ShoppingBag size={20} className="ml-2" />{" "}
                  </button>
                ) : (
                  ""
                )}
                <Link to={`/dashboard/chat/${product.sellerId}`} className="">
                  <button className="flex items-center nex_button font-semibold text-gray-700 hover:bg-gray-100 hover:text-gray-900 h-[40px]">
                    Chat seller <MessageSquare size={20} className="ml-2" />{" "}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="flex flex-wrap">
            <div className="w-[72%] md-lg:w-full">
              <div className="pr-4 md-lg:pr-0">
                <div className="grid grid-cols-2">
                  <button
                    onClick={() => setState("description")}
                    className={` px-5 py-3 hover:text-gray-900 font-bold rounded-full  ${
                      state === "description" ? "text-gray-900 bg-gray-100" : "text-gray-500"
                    } `}
                  >
                    Description
                  </button>
                  <button
                    onClick={() => setState("reviews")}
                    className={`rounded-full hover:text-gray-900 px-5  py-3 font-bold  ${
                      state === "reviews" ? " text-gray-900 bg-gray-100" : "text-gray-500"
                    } `}
                  >
                    Reviews
                  </button>
                </div>
                <div>
                  {state === "reviews" ? (
                    <Reviews product={product} />
                  ) : (
                    <p className="py-5 text-gray-700 whitespace-pre-wrap break-words">{product.description}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="w-[28%] md-lg:w-full">
              <div className="pl-4 md-lg:pl-0">
                <div className="sm:px-0 px-3 text-gray-700">
                  <h2 className="flex items-center justify-end">
                    {" "}
                    More from {product.shopName}{" "}
                    <Package className="ml-2" size="18" />
                  </h2>
                </div>
                <div className="flex flex-col gap-5 mt-3 p-3 sm:p-0">
                  {moreProducts.length === 0 ? (
                    <p className="text-sm font-bold text-gray-500">
                      No more products from this shop
                    </p>
                  ) : (
                    moreProducts.map((p, i) => {
                      return (
                        <Link
                          className="block bg-white border border-gray-100"
                          to={`/product/details/${p._id}`}
                          key={i}
                        >
                          <div className="relative h-[270px]">
                            <img
                              className="w-full h-full nex_img_cover"
                              src={p.images[0]}
                              alt={p.name}
                            />
                            {p.discount !== 0 && (
                              <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-red-600 font-semibold text-s left-2 top-2">
                                {p.discount}%
                              </div>
                            )}
                          </div>
                          <h2 className="text-gray-900 pt-4 px-2">{p.name}</h2>
                          <div className="flex gap-2 px-2">
                            <h2 className="text-gray-900 text-lg font-bold">
                              {formatCurrency(p.price, currencyCode, exchangeLoaded)}
                            </h2>
                            <div className="flex items-center gap-2">
                              <Ratings ratings={p.rating} />
                            </div>
                          </div>
                        </Link>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <h2 className="text-xl py-8 text-gray-900">Related Products</h2>
          <div>
            <Swiper
              slidesPerView="auto"
              breakpoints={{
                1280: {
                  slidesPerView: 3,
                },
                565: {
                  slidesPerView: 2,
                },
              }}
              spaceBetween={25}
              loop={true}
              pagination={{
                clickable: true,
                el: ".custom_bullet",
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
              {relatedProducts.map((p, i) => {
                return (
                  <SwiperSlide key={i}>
                    <Link className="block bg-white border border-gray-100" to={`/product/details/${p._id}`}>
                      <div className="relative h-[270px] ">
                        <div className="w-full h-full">
                          <img
                            className="w-full h-full nex_img_cover"
                            src={p.images[0]}
                          />
                        </div>
                        {p.discount !== 0 && (
                          <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-red-600 font-semibold text-s left-2 top-2">
                            {p.discount}%
                          </div>
                        )}
                      </div>
                      <div className="pt-4 flex flex-col gap-1 px-2">
                        <h2 className="text-gray-900">{p.name}</h2>
                        <div className="flex justify-start items-center gap-3">
                          <h2 className="text-lg font-bold text-gray-900">{formatCurrency(p.price, currencyCode, exchangeLoaded)}</h2>
                          <div className="flex">
                            <Ratings ratings={p.rating} />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <div className="w-full flex justify-center items-center py-10">
            <div className="custom_bullet justify-center gap-3 !w-auto"></div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Details;
